<!--
  Created 31.07.2023
  Modal for editing entity notes.
-->
<template>
  <div :class="{'flex flex-col px-[1px]':fillSpace}">
    <div
      class="border bg-yellow-50 p-2 text-sm font-medium"
      :class="fillSpace ? 'border-yellow-100' : 'border-dotted border-yellow-500 border-b-yellow-300'">
      Team-shared note about this place
    </div>
    <TextEditableTextarea
      v-model="note"
      :tab-rows="fillSpace ? false : 3"
      :auto-grow="!fillSpace"
      :text-area-class="'m-0 p-2 bg-yellow-50 bg-opacity-50 border border-t-0 text-xs' + (fillSpace ? ' h-full !border-solid !border-yellow-100' : ' !border-dotted !border-yellow-500')"
      :class="{'grow':fillSpace}"
      :buttons-wrapper-class="fillSpace ? 'absolute bottom-0 right-0' : ''"
      :save-button-class="fillSpace ? '!rounded-none' : ''"
      :cancel-button-class="fillSpace ? '!rounded-bl-none !rounded-tl-md' : ''"
      @save="(value) => updateNote(value)" />
  </div>
</template>

<script setup>
import {
  ref,
} from 'vue';
import { notify } from 'notiwind';
import TextEditableTextarea from '@/Components/Forms/TextEditableTextarea.vue';

const props = defineProps({
  routeProp: {
    type: String,
    required: true,
  },
  entity: {
    type: Object,
    required: true,
  },
  fillSpace: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const note = ref(props.entity.note?.note ?? '');

/**
 *
 * @param value
 */
function updateNote(value) {
  axios.post(props.routeProp, {
    note: value,
  }).then(() => {
    notify({
      type: 'success',
      title: 'Saved',
      text: 'Note was updated!',
    }, 4000);
  }).catch((error) => {
    // notify user of error
    notify({
      type: 'danger',
      title: 'Something went wrong',
      text: 'Could not save note! Please try again.',
    }, 4000);
    // log error
    console.error('save error: ', error);
  });
}

</script>
